module.exports = __webpack_public_path__ + "static/media/mode-pdb-logo-ripeurs-white.4b03be3a.png";